import Button from 'components/Button';
import cashierActions from 'features/cashier/services/actions';
import cashierSelectors from 'features/cashier/services/selectors';
import React from 'react';
import { useAppDispatch } from 'store/hooks';

const ButtonSimpleMenu = () => {
  const dispatch = useAppDispatch();
  const activeQuickMenu = cashierSelectors.getActiveQuickMenu();

  const handlePress = () => dispatch(cashierActions.activeQuickMenu(!activeQuickMenu));

  return (
    <Button block ntype={activeQuickMenu ? 'PRIMARY' : 'SECONDARY'} onClick={handlePress}>
      <span style={{ color: activeQuickMenu ? '#fff' : '#1D2129' }}>Simple Menu</span>
    </Button>
  );
};

export default ButtonSimpleMenu;
